import React, { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import accreditationPrintingService from '../../../../services/accreditationPrintingService';

// Renders the saved template against a real user (server-side PDF) and opens it in a new tab.
const TestWithUserModal = ({ show, onHide, templateId, userTypeId }) => {
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [renderingId, setRenderingId] = useState(null);

  useEffect(() => {
    if (!show || !userTypeId) return undefined;
    let stale = false;
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await accreditationPrintingService.getSampleUsers({ user_type_id: userTypeId, search });
        if (!stale) setUsers(res?.data || []);
      } catch (e) {
        if (!stale) Swal.fire('Error', e.response?.data?.message || e.message, 'error');
      } finally {
        if (!stale) setLoading(false);
      }
    }, 300);
    return () => { stale = true; clearTimeout(t); };
  }, [show, userTypeId, search]);

  const render = async (u) => {
    setRenderingId(u.registration_data_id);
    try {
      const blob = await accreditationPrintingService.renderOne(u.registration_data_id, { template_id: templateId });
      window.open(URL.createObjectURL(blob), '_blank');
    } catch (e) {
      let msg = e.message;
      try { msg = JSON.parse(await e.response.data.text()).message || msg; } catch { /* keep msg */ }
      Swal.fire('Render Failed', msg, 'error');
    } finally {
      setRenderingId(null);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-5">Test with a real user</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          className="form-control form-control-sm mb-3"
          placeholder="Search name / email (this user type, approved only)"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {loading && <Spinner size="sm" animation="border" />}
        {!loading && !users.length && <p className="text-muted small mb-0">No eligible users found for this user type.</p>}
        <ul className="list-group">
          {users.map((u) => (
            <li key={u.registration_data_id} className="list-group-item d-flex justify-content-between align-items-center">
              <span>
                {u.name} <small className="text-muted">#{u.registration_data_id}</small>
              </span>
              <button className="btn btn-outline-primary btn-sm" disabled={renderingId !== null} onClick={() => render(u)}>
                {renderingId === u.registration_data_id ? <Spinner size="sm" animation="border" /> : 'Render PDF'}
              </button>
            </li>
          ))}
        </ul>
      </Modal.Body>
    </Modal>
  );
};

export default TestWithUserModal;
